import { z } from 'zod/v4';

/**
 * One row of `GET /risk-analysis/metrics` — the metrics a risk rule's score
 * formula can reference (`SEVERITY`, `LIKELIHOOD`, `COMPANY_LEVERAGE`).
 *
 * Narrowed from the legacy `2025-06/risk-analysis-service` metrics list, which
 * also returned `description` and accepted `page`/`count`/`filter`/`sort`: its
 * one caller (the rule editor's prioritization form) reads only `id` and
 * `value` and sends no params.
 */
export const RiskMetricRowSchema = z.object({
  id: z.string(),
  value: z.string(),
});

export type RiskMetricRow = z.infer<typeof RiskMetricRowSchema>;
